<div class="container">
  <div class="row">
    <div class="col-12">
      <img
        src="https://foxpost.hu/img/page-404-bg-img.svg"
        class="d-block mx-auto w-25"
      />
    </div>
    <div class="col-12 text-center">
      <h1 class="foxpost-title">Not Found (#404)</h1>
    </div>
    <div class="col-12 text-center">
      <h3>A keresett oldal nem található</h3>
    </div>
    <div class="col-12 text-center">
      <a mat-flat-button href="/" class="primary-btn">Vissza a főoldalra</a>
    </div>
  </div>
</div>
